export default "__VITE_ASSET__D9TZIu8v__"